import { ChannelsGrid, ChannelsContext, FiltersSectionProps } from "@kaltura/mediaspace-shared-channels-grid";
import { useMemo } from "react";
import { FilterValues } from "@kaltura/mediaspace-shared-types";

interface GalleryChannels extends Pick<FiltersSectionProps, "filters"> {
    /**
     * pagination page size
     */
    pageSize: number;

    /**
     * initial filter values
     */
    initialValues?: FilterValues;

    /**
     * subscribe url
     */
    subscribeUrl: string;

    /**
     * unsubscribe url
     */
    unsubscribeUrl: string;

    /**
     * search url
     */
    searchUrl: string;
}

export const GalleryChannels = ({
    pageSize,
    subscribeUrl = "",
    unsubscribeUrl = "",
    initialValues,
    filters,
    searchUrl,
}: GalleryChannels) => {
    const channelsContextValue = useMemo(
        () => ({
            pageSize,
            subscribeUrl,
            unsubscribeUrl,
            allowCreateChannel: false,
            searchUrl,
        }),
        [pageSize, searchUrl, subscribeUrl, unsubscribeUrl]
    );

    return (
        <ChannelsContext.Provider value={channelsContextValue}>
            <ChannelsGrid initialValues={initialValues} filters={filters} reflectSelectedFiltersInQueryString={false} />
        </ChannelsContext.Provider>
    );
};
